import { useSelector } from 'react-redux';
import { MemberRegistrationType } from '@la/types';
import { formatAsUSD } from '@la/utilities';
import {
  getRegistrantContext,
  useRegistration,
} from 'lib/context/RegistrationContext/RegistrationContext';
import { useRegistrationAddOns } from 'redux/hooks/useRegistrationAddOns';
import { selectSelectedProducts } from 'redux/selectors/registrationAddOnsSelectors';

export function useMiniCart() {
  const { ctx, feeValue: registrationCost } = useRegistration();
  const { getTotalProductCost } = useRegistrationAddOns();

  const { registrationTypeLabel } = getRegistrationTypeLabel(ctx);
  const registrationTypeCost = registrationCost
    ? formatAsUSD(Number(registrationCost))
    : 'TBD';

  const selectedProducts = useSelector(selectSelectedProducts);
  const productCosts = getTotalProductCost();
  const totalCost = formatAsUSD(productCosts + Number(registrationCost ?? 0));

  return {
    registrationTypeCost,
    registrationTypeLabel,
    selectedProducts,
    totalCost,
  };
}

function getRegistrationTypeLabel(
  ctx: ReturnType<typeof getRegistrantContext>
) {
  let registrationType: MemberRegistrationType | null;
  let registrationTypeLabel;
  switch (ctx?.type) {
    case 'PLAYER':
      registrationType = 'player';
      registrationTypeLabel = 'Player Registration';
      break;
    case 'PLAYER_FREE_AGENT':
      registrationType = 'player';
      registrationTypeLabel = 'Player Free Agent Registration';
      break;
    case 'STAFF':
      registrationType = 'staff';
      registrationTypeLabel = 'Staff Registration';
      break;
    case 'STAFF_FREE_AGENT':
      registrationType = 'staff';
      registrationTypeLabel = 'Staff Free Agent Registration';
      break;
    default:
      registrationType = null;
      registrationTypeLabel = 'Registration';
  }
  return { registrationType, registrationTypeLabel };
}
